/** Max files per approve / need-more-info action (must match backend). Register admin uses separate limit (10). */
export const MAX_APPROVER_ACTION_ATTACHMENTS = 5;

/** Multipart field for optional approver note on annexure actions (must match backend). */
export const APPROVER_COMMENT_FIELD = 'approver_comment';
